import React, { useEffect } from 'react'
import type { AppState } from '../../App';
import { PageType } from '../../interfaces/types';
import MessageCard from './MessageCard';

import styled from 'styled-components'

import title from './title.svg'

const StyledDiv = styled.div`
  padding: 58px 10% 0 10%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
`


const manifesto = [
  '하나',
  '둘',
  '셋',
  '넷',
  '다섯',
]
const ResultPage = (props: {
  setCurrentPage: (page: PageType) => void;
  loadData: () => Promise<void>;
  state: AppState
}) => {

  useEffect(() => {
    if(!props.state.dataLoaded) {
      props.loadData();
    }
  })

  return (
    <>
    <StyledDiv>
      <img src={title} alt="산책캠프에 전달된 성남 시민들 고민" />
    </StyledDiv>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '0 10% 10% 10%',
        marginTop: '10px',
      }}
    >
      {
        props.state.data.length > 0 ? props.state.data.filter(row => row[0].replaceAll(' ', '').length !== 0).map((row, index) => {
          const messageCard = (
            <MessageCard
              setCurrentPage={props.setCurrentPage}
              key={index}
              message={row[0]}
              demo={`${row[1]} ${row[2]}`}
              id={row[4]}
            />
          )
          if (index === 0) {
            return null
          }
          if (row[0].length === 0) {
            return null
          }
          if (index % 5 === 0) {
            return (
              <MessageCard
                isManifesto
                key={`Manifesto-${Math.round(index/7)}`}
                message={manifesto[Math.round(Math.random() * (manifesto.length -1))]}
                demo='이대호'
              />
            )
          }
          return messageCard
        })
        :
        <div
        style={{
          width: '100%',
          color: '#fff',
          fontSize: '1.2em',
          wordBreak: 'keep-all',
          textAlign: 'center',
          fontWeight: 'bold',
          padding: '1em',
          boxSizing: 'border-box',
          fontFamily: 'GMarketSansMedium'
        }}
        >설문을 완료하시기 전에는 <br/>결과를 볼 수 없어요 :(
        <button>
          설문하러가기
        </button>  
        </div>
      }
    </div>
    </>
  )
}

export default ResultPage